import { useAuth } from "../lib/auth.tsx";

/**
 * Shown to a Cognito user who has signed in but has no `custom:tenantId`
 * attribute yet. Until the self-service tenant-creation flow exists,
 * tenant linking is a manual step.
 */
export function NoTenantPage() {
  const { signOut } = useAuth();
  return (
    <div className="grid min-h-screen place-items-center px-4">
      <div className="max-w-md space-y-4 rounded-xl border border-slate-200 bg-white p-6 text-sm">
        <p className="font-semibold text-slate-900">Almost there.</p>
        <p className="text-slate-600">
          Your account isn't linked to a tenant yet. Email
          <a
            href="mailto:support@spotmesh.cloud"
            className="mx-1 text-brand-700 hover:underline"
          >
            support@spotmesh.cloud
          </a>
          with your sign-up email and we'll provision your vendor profile.
        </p>
        <button
          type="button"
          onClick={signOut}
          className="rounded-md border border-slate-300 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
